// Centralized site config for Carpet & Lino Fitted by A.Moffat
export const SITE = {
  brand: "Carpet & Lino Fitted by A.Moffat",
  shortBrand: "A.Moffat Flooring",
  tagline: "Quality Flooring Fitted To Perfection",
  microTagline: "Quality Work • Great Finish • Built To Last",
  phone: "07956 115049",
  phoneIntl: "447956115049",
  phoneTel: "+447956115049",
  email: "adammoffat1605@icloud.com",
  website: "floorsbyamoffat.co.uk",
  websiteUrl: "https://floorsbyamoffat.co.uk",
  whatsappUrl: "https://wa.me/447956115049",
  whatsappButtonImg:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/ut4jhwrn_WhatsAppButtonGreenSmall.png",
  // TODO: replace with real Checkatrade & Trustpilot profile URLs
  checkatradeUrl: "https://www.checkatrade.com/",
  trustpilotUrl: "https://uk.trustpilot.com/",
  facebookUrl: "https://www.facebook.com/share/1E5TZoRRbX/?mibextid=wwXIfr",
  googleUrl: "https://share.google/WBuNSVH01vWGEtnRJ",
  coverage: "County Durham & the North East",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/qik9gvk3_Logo.png",
  qrUrl:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/vs91kvt8_QRCode%20%281%29.png",
  heroBannerUrl:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/qp5r1z52_47c111a6-58cb-4efb-bb05-cee0d121ea61.png",
};

// User's branded marketing posters (kept for accents)
export const BRAND_POSTERS = {
  cover:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/qu81p6xk_cover%20best.png",
  carpets:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/wc7w21g1_Carpets.png",
  domestic:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/w0nevtqt_domestic.png",
  damp:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/82mm9kk4_damp.png",
  company:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/80le7s03_Company.png",
  quote:
    "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/eikf3sot_Qote.png",
};

export const TOWNS = [
  "Durham",
  "Chester-le-Street",
  "Consett",
  "Stanley",
  "Bishop Auckland",
  "Newton Aycliffe",
  "Spennymoor",
  "Seaham",
  "Peterlee",
  "Hartlepool",
  "Darlington",
  "Barnard Castle",
  "Crook",
  "Shildon",
  "Ferryhill",
];

export const SERVICES = [
  {
    key: "carpets",
    name: "Carpets",
    blurb:
      "Luxurious, hard-wearing carpets supplied and expertly fitted for any room of the home. A huge choice of colours, styles and pile depths — from cosy bedroom carpets to durable family-friendly options that look great and last for years.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/0qyfk0vq_Carpets.png",
  },
  {
    key: "lvt",
    name: "Luxury Vinyl Tiles (LVT)",
    blurb:
      "Premium herringbone, plank and tile LVT — beautifully realistic wood and stone finishes that are 100% waterproof, scratch-resistant and incredibly hard-wearing. Perfect for kitchens, bathrooms, hallways and living areas in any home or commercial setting.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/9hkbx4vs_LVT.png",
  },
  {
    key: "laminate",
    name: "Laminate Flooring",
    blurb:
      "The perfect combination of style, strength and value. Hardwearing, scratch & stain resistant, easy to clean and quick to install — laminate is a brilliant cost-effective option in a wide range of wood-effect styles and finishes.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/ho3sqngn_82433077-0490-4bd1-a930-b11a1dc78ece.png",
  },
  {
    key: "vinyl-lino",
    name: "Lino & Vinyl Flooring",
    blurb:
      "Practical, easy-clean lino and vinyl flooring in hundreds of styles and finishes. Water resistant, low maintenance and built for everyday family life — ideal for kitchens, bathrooms, utility rooms and high-traffic areas at home or work.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/32t8q72l_Lino.png",
  },
  {
    key: "stairs",
    name: "Stair Carpets & Runners",
    blurb:
      "Beautifully fitted stair carpets and runners with a flawless, fully-bound finish. From classic full stair carpets to elegant runners with show-wood — neat, safe and a real feature of your home, with expert tailoring around spindles and landings.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/qmwr312o_Stairs.png",
  },
  {
    key: "carpet-tiles",
    name: "Carpet Tiles",
    blurb:
      "Practical, hard-wearing carpet tiles ideal for offices, shops, schools and commercial spaces. Easy to replace individual tiles if damaged, available in a wide variety of colours, and supplied & fitted to a professional commercial standard.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/rsa73vuc_tiles.png",
  },
  {
    key: "safety",
    name: "Safety Flooring",
    blurb:
      "Slip-resistant safety flooring for kitchens, bathrooms, schools, care homes and any commercial environment. Hygienic, easy-clean and compliant with safety standards — total peace of mind for high-risk and wet areas.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/8n3rzxuz_safe.png",
  },
  {
    key: "commercial",
    name: "Domestic & Commercial",
    blurb:
      "Complete flooring solutions for homes, offices, retail, schools and care homes. Whether it's a single room or an entire premises, we deliver a professional, reliable service with high-quality products and a clean, respectful finish — every time.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/0xh23y1l_domestic.png",
  },
  {
    key: "landlord",
    name: "Landlord & Letting",
    blurb:
      "Reliable, hard-wearing flooring for rental properties with quick turnarounds and competitive pricing. Trusted by local landlords and letting agents — designed to look great, withstand tenant wear and protect your investment long-term.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/qzfgtugz_Landlord.png",
  },
  {
    key: "screed",
    name: "Floor Screeding & Preparation",
    blurb:
      "Professional screeding and full floor preparation — the perfect start for a perfect finish. A smooth, level base means your new flooring will look better, perform better and last far longer.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/9idr15ec_Screed.png",
  },
  {
    key: "subfloor",
    name: "Subfloor Repairs & Levelling",
    blurb:
      "Expert repairs to damaged subfloors, levelling and smoothing of uneven floors, plus filling of bumps, dips and imperfections. The hidden essential that makes everything fitted on top look immaculate and stay that way.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/8rttkez1_sub.png",
  },
  {
    key: "damp",
    name: "Damp Proof Membranes",
    blurb:
      "Our DPM installations provide a reliable barrier against rising damp — protecting your subfloor, your new flooring and the long-term health of your home. Ideal for concrete floors, basements, ground floors, renovations and new builds.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/l5cg55zk_damp.png",
  },
  {
    key: "uplift",
    name: "Uplift & Disposal",
    blurb:
      "We remove your old flooring, adhesive and underlay so you don't have to lift a finger. Full disposal, no mess left behind and your subfloor cleaned & prepared ready for your beautiful new finish — fast, clean and responsibly recycled where possible.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/dey2dvqx_Uplift.png",
  },
  {
    key: "free-quote",
    name: "Free Measure & Quotation",
    blurb:
      "Accurate. No obligation. Completely free. We come to your home or site, take precise measurements, give expert advice on the best options and provide a competitive written quote — all at no cost and with no pressure to commit.",
    image:
      "https://customer-assets.emergentagent.com/job_flooring-mobile/artifacts/eikf3sot_Qote.png",
  },
];

export const CLIENTS = [
  "Homeowners",
  "Landlords",
  "Letting Agents",
  "Property Developers",
  "Builders",
  "Shops & Retail",
  "Offices",
  "Schools",
  "Care Homes",
  "Commercial Premises",
];

export const REASONS = [
  { label: "Free Measure & Quote", icon: "Ruler" },
  { label: "20+ Years Experience", icon: "Award" },
  { label: "Fully Insured", icon: "ShieldCheck" },
  { label: "Domestic & Commercial", icon: "Building2" },
  { label: "Landlord Specialists", icon: "KeyRound" },
  { label: "Quality Workmanship", icon: "Sparkles" },
  { label: "Competitive Prices", icon: "Tag" },
  { label: "Friendly Local Service", icon: "Smile" },
];
